import Footer from "../../components/footer/Footer";
import PreviousQuestionButton from "./header/PreviousQuestionButton";
import Question from "./question/Question";
import "./application.scss";
import Summary from "./templates/Summary";
import Overlay from "components/ui/loading-spinners/Overlay/Overlay";
import { useGetApplicationByIdQuery, useSetApplicationStepAnswerMutation } from "./applicationService";
import { useSelector, useDispatch } from "react-redux";
import { getCurrentUserApplicationId, setLogout, getVersion, setNhApplicationStatus } from "features/authSlice";
import { getStepData } from "pages/application/question/questionSlice";
import { useNavigate } from "react-router-dom";
import { userVersionFeatureMap, UserVersion, UserFeature } from "utilities/UserversionFeatures";
import { Loader } from "components/Loader/Loader";
import usePerformRouting from "features/PerformRouting";
import { useEffect, useState } from "react";
import Transition from "./transition/Transition";
import { useGetFeatureFlagsQuery } from "services/common/featureFlagService";

const ApplicationContainer = () => {
  const stepData = useSelector(getStepData);
  const applicationId = useSelector(getCurrentUserApplicationId);
  const { data: featureFlag, isSuccess: isFeatureFlagSuccess } = useGetFeatureFlagsQuery();
  const version = useSelector(getVersion);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isFetching, isError: isGetApplicationByIdError, error: getApplicationByIdError } = useGetApplicationByIdQuery(applicationId);
  const [_, { isLoading, isError: isSetApplicationStepAnswerError, error: setApplicationStepAnswerError }] = useSetApplicationStepAnswerMutation({
    fixedCacheKey: "updateApplication",
  });
  const { performRouting } = usePerformRouting();
  const [shouldNavigateToTraditionalDashboard, setShouldNavigateToTraditionalDashboard] = useState(false);

  useEffect(() => {
    performRouting();
  }, []);

  useEffect(() => {
    if (shouldNavigateToTraditionalDashboard) {
      setTimeout(() => {
        navigate("/dashboard"); //navigate to dashboard after min of 20seconds (18seconds transition + 2000ms in this timeout)
      }, 2000);
    }
  }, [shouldNavigateToTraditionalDashboard]);

  useEffect(() => {
    if (stepData.stepCodeText === "EndOfFlow" && isFeatureFlagSuccess && !featureFlag.needsListV2Enabled) {
      setTimeout(() => {
        navigate("/dashboard");
      }, 10000);
    }
  }, [isFeatureFlagSuccess, stepData.stepCodeText]);

  function getApplicationStepAnswerError() {
    if (
      typeof setApplicationStepAnswerError === "object" &&
      "status" in setApplicationStepAnswerError &&
      setApplicationStepAnswerError.status === 401
    ) {
      dispatch(setLogout());
      navigate("/", { state: { previousPath: "/application" } });
    }
  }
  function getApplicationIdError() {
    if (typeof getApplicationByIdError === "object" && "status" in getApplicationByIdError && getApplicationByIdError.status === 401) {
      dispatch(setLogout());
      navigate("/", { state: { previousPath: "/application" } });
    }
  }
  if (isGetApplicationByIdError) {
    getApplicationIdError();
  } else if (isSetApplicationStepAnswerError) {
    getApplicationStepAnswerError();
  }
  const versionFeatures = userVersionFeatureMap[version.toUpperCase() as UserVersion];
  //for V2 user => dashboard , V1 user => Thankyou page
  if (stepData.stepCodeText === "EndOfFlow") {
    if (versionFeatures?.includes(UserFeature.SHOW_DASHBOARD)) {
      const nhApplicationStatus = "Completed";
      dispatch(setNhApplicationStatus(nhApplicationStatus));

      return (
        <div className="loader-dashboard">
          {featureFlag?.needsListV2Enabled ? (
            <Transition onComplete={() => setShouldNavigateToTraditionalDashboard(true)} />
          ) : (
            <>
              <Loader message1="One moment!" message2="Creating your custom dashboard" />
            </>
          )}
        </div>
      );
    }
  }

  if (isFetching || isLoading) {
    return <Overlay />;
  }

  if (!stepData) {
    throw new Error("No data");
  }
  const isSummary = stepData?.stepType === "summary";

  return (
    <div className="application">
      {!isSummary && <PreviousQuestionButton />}
      {isSummary ? <Summary /> : <Question />}
      <Footer />
    </div>
  );
};

export default ApplicationContainer;
